import { handleActions } from 'redux-actions';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  companyDetails: {
    count: 0,
    custom_rates: [],
    departments: [],
    contacts: [],
    events: [],
    payment: null,
    ltaWorkers: [],
    favAndBlocks: []
  },
  companiesList: [],
  searchResults: [],
  pagesQuantity: 0
};

export default handleActions(
  {
    [actionTypes.GET_COMPANY_DETAILS_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        ...action.companyDetails
      }
    }),
    [actionTypes.EDIT_COMPANY_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        ...action.data
      }
    }),
    [actionTypes.ADD_CUSTOM_RATE_SUCCESS]: (state, action) => {
      const existingCustomRates = state.companyDetails.custom_rates || initialState.companyDetails.custom_rates;

      return {
        ...state,
        companyDetails: {
          ...state.companyDetails,
          custom_rates: [ ...existingCustomRates, action.data ]
        }
      };
    },
    [actionTypes.DELETE_CUSTOM_RATE_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        custom_rates: state.companyDetails.custom_rates.filter(rate => rate.id !== action.data)
      }
    }),
    [actionTypes.GET_ALL_COMPANIES_SUCCESS]: (state, action) => ({
      ...state,
      companiesList: action.companiesList,
      pagesQuantity: action.pagesQuantity
    }),
    [actionTypes.GET_COMPANY_CONTACTS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        contacts: action.data
      }
    }),
    [actionTypes.GET_COMPANY_DEPARTMENTS_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        departments: action.data
      }
    }),
    [actionTypes.GET_COMPANY_EVENTS_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        events: action.data
      }
    }),
    [actionTypes.SEARCH_COMPANIES_BY_NAME_SUCCESS]: (state, action) => ({
      ...state,
      searchResults: action.data
    }),
    [actionTypes.SEARCH_COMPANIES_BY_NAME_CLEAR_RESULTS]: state => ({
      ...state,
      searchResults: initialState.searchResults
    }),
    [actionTypes.GET_COMPANY_PAYMENT_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        payment: action.data
      }
    }),
    [actionTypes.CLEAR_COMPANY_DETAILS]: state => ({
      ...state,
      companyDetails: initialState.companyDetails
    }),
    [actionTypes.GET_LTA_WORKERS_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        ltaWorkers: action.data
      }
    }),
    [actionTypes.CLEAR_LTA_WORKERS]: state => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        ltaWorkers: initialState.companyDetails.ltaWorkers
      }
    }),
    [actionTypes.GET_FAV_AND_BLOCKS_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        count: action.count,
        favAndBlocks: action.data
      }
    }),
    [actionTypes.CLEAR_FAV_AND_BLOCKS]: state => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        favAndBlocks: initialState.companyDetails.favAndBlocks
      }
    }),
    [actionTypes.POST_FAV_BLOCK_WORKER_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        favAndBlocks: [ ...state.companyDetails.favAndBlocks, action.data ]
      }
    }),
    [actionTypes.PUT_FAV_BLOCK_WORKER_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        favAndBlocks: [
          ...state.companyDetails.favAndBlocks.filter(worker => worker.id !== action.data.id),
          action.data
        ]
      }
    }),
    [actionTypes.DELETE_FAV_BLOCK_WORKER_SUCCESS]: (state, action) => ({
      ...state,
      companyDetails: {
        ...state.companyDetails,
        favAndBlocks: state.companyDetails.favAndBlocks.filter(worker => worker.id !== action.data.id)
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/companies.js